import React, { type FC } from 'react';

import type {
	UserPrincipal,
	GroupOrTeamPrincipal,
	Principal,
	KnownErrors,
	Role,
} from '../../../../commonTypes.tsx';

import { DeletedGroupDetails } from './DeletedGroupDetails.tsx';
import { UserDetails } from './UserDetails.tsx';
import { GroupDetails } from './GroupDetails.tsx';

export type PrincipalDetailsProps = {
	principal: Principal;
	isYou: boolean;
	role: Role;
	updateKnownErrors?: (id: string, errors: KnownErrors) => void;
	isDraft: boolean;
	shouldShowDeletedGroupDetails: boolean;
};

export const PrincipalDetails: FC<PrincipalDetailsProps> = ({
	principal: { type, ...typeSpecificProps },
	isYou,
	updateKnownErrors,
	role,
	isDraft,
	shouldShowDeletedGroupDetails,
}) => {
	if (shouldShowDeletedGroupDetails) {
		return <DeletedGroupDetails />;
	}
	if (type === 'user') {
		return (
			<UserDetails
				{...(typeSpecificProps as UserPrincipal)}
				isYou={isYou}
				updateKnownErrors={updateKnownErrors}
				role={role}
				isDraft={isDraft}
			/>
		);
	} else {
		return <GroupDetails {...(typeSpecificProps as GroupOrTeamPrincipal)} />;
	}
};
